import raw from "./parameter_map.json";

export const PARAMETER_MAP = raw;
